import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useCustomer } from "@/context/CustomerAuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "@/pages/customer/AuthShell";
import { Field } from "@/pages/customer/SignUp";

export default function SignIn() {
  const { customer, login } = useCustomer();
  const nav = useNavigate();
  const loc = useLocation();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (customer) return <Navigate to="/my-account" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(identifier, password);
      toast.success("Welcome back");
      nav(loc.state?.from || "/my-account", { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Customer account" title="Sign in" subtitle="Use your email address or mobile number." testid="signin-page">
      <form onSubmit={submit} className="space-y-4" data-testid="signin-form">
        <Field id="si-identifier" label="Email or Mobile Number" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required autoComplete="username" placeholder="you@example.com or 98XXXXXXXX" />
        <Field id="si-password" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
        <div className="flex justify-end">
          <Link to="/account/forgot-password" className="text-xs text-muted-foreground hover:text-primary underline" data-testid="si-forgot-link">Forgot password?</Link>
        </div>
        <Button type="submit" disabled={busy} className="w-full rounded-none h-11 gap-2 font-bold uppercase tracking-wide" data-testid="si-submit">
          {busy ? "Signing in…" : <>Sign in <ArrowRight className="h-4 w-4" /></>}
        </Button>
        <p className="text-center text-sm text-muted-foreground">New to Arrow? <Link to="/signup" className="text-primary font-semibold hover:underline" data-testid="si-signup-link">Create an account</Link></p>
      </form>
    </AuthShell>
  );
}
